import { makeAutoObservable } from "mobx";
export class PurchaseOrderStorageData {
    constructor(params) {
        this.purchaseOrder = params.purchaseOrder;
        this.inCartPromotionTypes = params.inCartPromotionTypes;
        makeAutoObservable(this);
    }
    get cartStorageData() {
        return {
            restaurantId: this.purchaseOrder.restaurantId.value,
            couponCode: this.inCartPromotionTypes.couponCode,
            purchaseOrderPayload: this.purchaseOrder.payload.storageData,
            promotionScheme: this.purchaseOrder.promotionScheme.storageData,
        };
    }
    get fulfillmentTimeStorageData() {
        const { fulfillmentTime } = this.purchaseOrder.fulfillmentInstructions;
        if (fulfillmentTime === null) {
            return null;
        }
        return fulfillmentTime.storageData;
    }
    get streetAddressStorageData() {
        const { streetAddress } = this.purchaseOrder.fulfillmentInstructions;
        if (streetAddress === null) {
            return null;
        }
        return streetAddress.storageData;
    }
    get apartmentInfoStorageData() {
        const { apartmentInfo } = this.purchaseOrder.fulfillmentInstructions;
        if (apartmentInfo === null) {
            return null;
        }
        return apartmentInfo.storageData;
    }
    get contactDetailsStorageData() {
        return this.purchaseOrder.contactDetails.storageData;
    }
    get invoiceDetailsStorageData() {
        const { invoiceDetails } = this.purchaseOrder;
        if (invoiceDetails === null) {
            return null;
        }
        return invoiceDetails.storageData;
    }
    get consentsStorageData() {
        return this.purchaseOrder.consents.storageData;
    }
    get paymentMediumStorageData() {
        return this.purchaseOrder.fulfillmentInstructions.paymentMedium;
    }
    get fulfillmentMethodType() {
        return this.purchaseOrder.fulfillmentInstructions.fulfillmentMethodType;
    }
}
